import "./index.css";

const Button = ({
  onClickHandler,
  title,
  fullWidth = false,
  centered = false,
  type = "button",
  ...rest
}) => {
  return (
    <button
      onClick={onClickHandler}
      className={`customButton ${fullWidth ? "fullWidth" : ""} ${
        centered ? "centered" : ""
      }`}
      type={type}
      {...rest}
    >
      {title}
    </button>
  );
};

export default Button;
